export function getTweenMax() {

    return window.TweenMax || null
}

export function getTimelineMax() {
    return window.TimelineMax || null
}


// WEBPACK FOOTER //
// ./src/helpers/gsap.js